import { render, staticRenderFns } from "./OverviewFinalize.vue?vue&type=template&id=4b6cbbba"
import script from "./OverviewFinalize.vue?vue&type=script&lang=js"
export * from "./OverviewFinalize.vue?vue&type=script&lang=js"
import style0 from "./OverviewFinalize.vue?vue&type=style&index=0&id=4b6cbbba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports